import { TenantProfile } from "@hydrologiq/gql/graphql"
import { useGetProfile } from "@hydrologiq/shared/providers/helpers/useProfile"
import RentalHeadlines from "./RentalHeadlines"
import CustomersHeadlines from "../CustomersHeadlines"
import { useUnifiedHeadlines } from "../../hooks/useUnifiedHeadlines"

function ProfileAwareHeadlines() {
  const profile = useGetProfile()
  const { data, loading, error } = useUnifiedHeadlines()

  // Show rental headlines for rental profile
  if (profile === TenantProfile.Rental) {
    return (
      <RentalHeadlines
        loading={loading}
        error={error?.message ?? null}
        assetsOnHire={data?.assetsOnHire ?? 0}
        totalAlerts={data?.totalAlerts ?? 0}
        totalCo2eYesterday={data?.totalCo2eYesterday ?? 0}
        earliestRunDryMinutes={data?.earliestRunDryMinutes}
        earliestRunDrySite={data?.earliestRunDrySite}
        earliestRunDryCustomer={data?.earliestRunDryCustomer}
        earliestInstallationRunDryMinutes={data?.earliestInstallationRunDryMinutes}
        earliestInstallationRunDrySite={data?.earliestInstallationRunDrySite}
        earliestInstallationRunDrySystem={data?.earliestInstallationRunDrySystem}
      />
    )
  }

  // Show fuel producer headlines for fuel producer profile
  return (
    <CustomersHeadlines
      totalOrdered={data?.totalOrdered ?? 0}
      totalConsumed={data?.totalConsumed ?? 0}
      averageOrder={data?.averageOrder ?? 0}
      returnedPerFulfillment={data?.returnedPerFulfillment ?? 0}
      returnedTrend={data?.returnedTrend ?? 0}
      earliestRunDryMinutes={data?.earliestRunDryMinutes}
      earliestRunDrySite={data?.earliestRunDrySite}
      earliestRunDryCustomer={data?.earliestRunDryCustomer}
      loading={loading}
      error={error?.message ?? null}
    />
  )
}

export default ProfileAwareHeadlines
